import { Edit } from "react-admin";
import { settings } from "app";
import { tenants } from "utils/tenants";
import PositionSaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";
import ApprovalSubstitutesSection from "./ApprovalSubstitutes/ApprovalSubstitutesSection";

const EditPositions = () => {
  return (
    <Edit
      title="Редакция на позиция"
      mutationMode="pessimistic"
      actions={<BackButtonToolbar />}
    >
      <PositionSaveForm />
      {/* Saved through its own endpoint, so it stays outside the position form. */}
      {settings.tenant === tenants.SU && <ApprovalSubstitutesSection />}
    </Edit>
  );
};
export default EditPositions;
